module.exports = __webpack_public_path__ + "static/media/SPECIAL_BEHAVIORAL_NEEDS.35ee2f08.svg";